import React from 'react';
import { MapPin, FileCheck, Award, Users, Shield, Handshake } from 'lucide-react';
import { whyChooseUs } from '../../data/mock';

const iconMap = {
  MapPin: MapPin,
  FileCheck: FileCheck,
  Award: Award,
  Users: Users,
  Shield: Shield,
  Handshake: Handshake
};

const WhyUsSection = () => {
  return (
    <section className="py-12 md:py-16 section-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="inline-block text-[#B5D43B] font-semibold text-sm tracking-wider uppercase mb-4">
            Why Choose Us
          </span>
          <h2 className="heading-2 mb-5">
            A Partner, Not Just an Installer
          </h2>
          <p className="body-large">
            We focus on education and long-term relationships, not high-pressure sales. 
            Your success is our success.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div 
                key={index} 
                className="flex gap-5 p-6 rounded-2xl bg-white border border-black/5 hover:shadow-lg transition-shadow"
              >
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-xl bg-[#B5D43B]/15 flex items-center justify-center">
                    <IconComponent className="w-6 h-6 text-[#3D5A47]" />
                  </div>
                </div>
                <div>
                  <h3 className="font-semibold text-base text-[#3D5A47] mb-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
